var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c(
        "div",
        {
          staticClass: "rb-crosslinks-wrapper --skeleton m-dynamic--x",
          class: { "--has-image": _vm.hasImage },
        },
        _vm._l(_vm.children.length, function (i) {
          return _c("div", {
            key: i,
            staticClass: "plp__dummy--crosslinks",
            class: { "--image": _vm.hasImage },
          })
        }),
        0
      )
    : _vm.categoryNames || (_vm.categoryNames && _vm.categoryNames.length > 0)
    ? _c(
        "rb-crosslinks-renderer",
        {
          attrs: {
            "category-names": _vm.categoryNames,
            "is-shortcode": _vm.isShortcode,
            "sanitize-shortcode": _vm.sanitizeShortcode,
            "has-swiper": true,
            "is-mobile": _vm.isMobile,
          },
        },
        [_vm._t("default")],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }